export default [
    {
        date: "2019-05-20",
        type: 'output'
    },{
        date: "2019-06-23",
        type: 'output'
    },{
        date: "2019-06-22",
        type: 'output'
    },{
        date: "2019-06-21",
        type: 'output'
    },{
        date: "2019-06-28",
        type: 'output'
    },{
        date: "2019-06-27",
        type: 'output'
    },{
        date: "2019-06-20",
        type: 'output'
    },{
        date: "2019-06-19",
        type: 'output'
    },{
        date: "2019-06-26",
        type: 'output'
    }
]